class ImageCarousel {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.slides = Array.from(wrapper.querySelectorAll('.carousel-slide'));
    this.dots = Array.from(wrapper.querySelectorAll('.carousel-dot'));
    this.prevBtn = wrapper.querySelector('.carousel-arrow--prev');
    this.nextBtn = wrapper.querySelector('.carousel-arrow--next');

    this.current = 0;
    this.autoplay = wrapper.dataset.autoplay === 'true';
    this.speed = parseInt(wrapper.dataset.speed, 10) || 4000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.start();
  }

  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restart();
      });
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restart();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restart();
      });
    });

    // Pausa al pasar el ratón por encima
    this.wrapper.addEventListener('mouseenter', () => this.stop());
    this.wrapper.addEventListener('mouseleave', () => {
      if (this.autoplay) this.start();
    });
  }

  goTo(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    if (this.autoplay) this.start();
  }
}

document.querySelectorAll('.carousel-wrapper').forEach((wrapper) => {
  new ImageCarousel(wrapper);
});

document.addEventListener('shopify:section:load', (event) => {
  const wrapper = event.target.querySelector('.carousel-wrapper');
  if (wrapper) new ImageCarousel(wrapper);
});
